var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-power"},[(_vm.link)?_c('iframe',{attrs:{"src":_vm.link,"frameborder":"0","allow":"fullscreen; autoplay","sandbox":"allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }